export enum TabKeys {
  OVERVIEW = 'overview',
  ONTOLOGIES = 'ontologies',
}
